//Reference: EN121

import { Mappeable } from './mappeable.model';
import moment from 'moment';
import * as _ from 'lodash';

export class TrainingData extends Mappeable {

    academicTraining: any;
    certifications: any;
    languages: any;
    comments: string;

    constructor(o) {
        super(o);
    }

    public mapToBack() {
        return {
            academicTraining: this.academicTraining,
            certifications: this.certifications,
            languages: this.languages,
            comments: this.comments
        }
    }
    /*
        transformCertifications(certifications) {
            let formatCertifications = []
            _.forEach(certifications, (certification) => {
                formatCertifications.push({ typeCertificationFk: certification })
            })
            return formatCertifications;
        }
    
    */
}